export default {
    size: 20
}